import { NgOptimizedImage } from '@angular/common';
import { afterNextRender, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'app-topbar',
  imports: [NgOptimizedImage, RouterLink],
  templateUrl: './topbar.html',
  styleUrl: './topbar.scss',
})
export class Topbar {
  public widthBrowser: any;

  constructor() {
    afterNextRender(() => {
      this.open();
    });
  }

  open() {
    const source = fromEvent(window, 'resize');
    source.subscribe(() => {
      if (typeof document !== 'undefined') {
        const display = document.getElementById('menuPurchase');
        display!.style.display = 'block';

        if (typeof window !== 'undefined') {
          this.widthBrowser = window.innerWidth;
        }
      }
    });
  }

  showCompanies() {
    if (typeof document !== 'undefined') {
      const display = document.getElementById('menuCompanies') as HTMLElement;
      display.style.display = 'block';
      const btnSities = document.getElementsByClassName('sities');
      if (!btnSities[0].classList.contains('open')) {
        btnSities[0].classList.add('open');
      }
    }
  }

  showCommerces() {
    if (typeof document !== 'undefined') {
      const display = document.getElementById('menu-purchase');
      display!.style.display = 'flex';
    }
  }
}
